import React from "react";
import { Routes, Route } from "react-router-dom";

import Index from "./view/Layout/Index";
import Login from "./view/Auth/Login";
import PrivateRoute from "./view/Routing/PrivateRoute";
function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/login" element={<Login />} />
        {/* <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} /> */}

        <Route element={<PrivateRoute />}>
          <Route path="/" element={<Index />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
